import { render, staticRenderFns } from "./loginComponent.vue?vue&type=template&id=5e47883a&scoped=true&"
import script from "./loginComponent.vue?vue&type=script&lang=js&"
export * from "./loginComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e47883a",
  null
  
)

export default component.exports